<template>
    <div class="meter-type-box">
        <flex>
            <el-table
                :data="meterFunctionList.slice((currentPage-1)*pagesize,currentPage*pagesize)" ref="table"
                stripe  size="smail"
                width="100%" height="100%"
                v-loading="loading"
                :header-row-style="{color:'black'}">
                <el-table-column
                        type="index"
                        label="序号"
                        :index="indexMethod"
                        align="center"
                >
                </el-table-column>
            <el-table-column
                    prop="code"
                    label="仪表型号"
                    align="center">
            </el-table-column>
                <template v-for="(col ,index) in header">
                    <el-table-column  :prop="col.id" :label="col.name" align="center"></el-table-column>
                </template>
            <!--<el-table-column-->
                    <!--prop="name"-->
                    <!--label="退费功能独立"-->
                    <!--align="center">-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="address"-->
                    <!--label="保电功能"-->
                    <!--align="center">-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="address"-->
                    <!--label="欠费跳闸使能"-->
                    <!--align="center">-->
            <!--</el-table-column>-->
        </el-table>
        </flex>
        <div class="page-number-box">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="meterFunctionList.length"
                    style="font-size:small;">
            </el-pagination>
        </div>
    </div>
</template>

<script>
  import Flex from '@/components/Flex'
  import { selectAcuFunction ,selectMeterAcuFunctionType} from '@/api/AcuFunction'
  import { getMeterlist} from '@/api/meterType'
  export default {
    name: "MeterType",
    components: {
      'flex': Flex
    },
    data(){
      return{
        header:[],//表头数据
        headerIds:[],//表头类型id
        meterFunctionList:[],
        currentPage: 1,//默认第一页
        pagesize: 10,//默认显示多少条
        loading:true
      }

    },
    mounted(){
        //查询表头
        this.fetchFunction();
        //查询所有仪表
      // this.fetchMeterlist()

    },
    methods:{
      fetchFunction:function () {
        selectAcuFunction().then(res => {
          if (res.code === 200) {
            this.header = res.infoJson
            for(let i=0;i<this.header.length;i++){
              this.headerIds.push(this.header[i].id)
            }
            console.log( this.headerIds)
            console.log( JSON.stringify( this.headerIds ));
            //查询各个仪表的功能
            this.fetchMeterAcuFunctionType();

          }
        }).catch(error => {
        })
      },
      // fetchMeterlist:function(){
      //   getMeterlist().then(res => {
      //     if (res.code === 200) {
      //       this.meterList = res.infoJson
      //
      //       console.log( this.meterList+"3333")
      //     }
      //   }).catch(error => {
      //   })
      // },
      fetchMeterAcuFunctionType:function (){
        selectMeterAcuFunctionType(this.headerIds).then(res => {
          this.meterFunctionList=res.infoJson
          this.loading=false
        }).catch(error => {
        })
      },
      handleSizeChange: function(size) {
        this.pagesize = size
        this.currentPage=1;
      },
      handleCurrentChange: function(currentPage) {
        this.currentPage = currentPage
      },
      indexMethod(index) {
        return (this.currentPage-1) * this.pagesize+index+1
      },
    }
  }
</script>

<style scoped >
    .meter-type-box{
        display:flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
        box-sizing: border-box;
    }
    .page-number-box{
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .meter-type-box .el-table::before {
        height: 0px;
    }
</style>